import { useEffect } from 'react';
export function useMountEffect(effect) {
    useEffect(() => {
        effect();
    }, []);
}
